export default __webpack_public_path__ + "static/media/christmas_corner_bottom.b682584c.png";